const ERROR_CODES = {
  COURSE_PLAN_CREATE: '1000',
};

export default ERROR_CODES;
